import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import styles from '../style/BreadCrumb.style';

function Breadcrumb({ breadCrumbData = [], className }) {
  const [styleClass, setStyleClass] = useState('');
  const [styleClass1, setStyleClass1] = useState('');
  const handleClick = (e) => {
    e.preventDefault();
    setStyleClass('not-visible');
    setStyleClass1('visible');
  };
  return (
    <section className={`${className}`}>
      <nav aria-label="Breadcrumb">
        <ul className="breadcrumbs">
          {breadCrumbData.map((breadcrumb, index, arr) => (
            <>
              {arr.length === index + 1 ? (
                <>
                  {arr.length > 2 && (
                    <li
                      key={`${breadcrumb.name}-elipsis`}
                      className={`enable-overflow ${styleClass}`}
                    >
                      <Anchor href="#" noLink onClick={handleClick}>
                        ...
                      </Anchor>
                    </li>
                  )}
                  <li key={breadcrumb.name} className="breadcrumb">
                    <Anchor
                      target="_self"
                      IsSlugPathAdded={false}
                      asPath={breadcrumb.path}
                      to={breadcrumb.to}
                      aria-current="true"
                    >
                      {breadcrumb.name}
                    </Anchor>
                  </li>
                </>
              ) : (
                <li
                  className={`breadcrumb
                  ${
                    index !== 0 && arr.length !== index + 1 ? `disable-overflow ${styleClass1}` : ``
                  }`}
                  key={breadcrumb.name}
                >
                  <Anchor
                    target="_self"
                    IsSlugPathAdded={false}
                    asPath={breadcrumb.path}
                    to={breadcrumb.to}
                  >
                    {breadcrumb.name}
                  </Anchor>
                </li>
              )}
            </>
          ))}
        </ul>
      </nav>
    </section>
  );
}
Breadcrumb.propTypes = {
  breadCrumbData: PropTypes.shape([]),
  className: PropTypes.string,
};
Breadcrumb.defaultProps = {
  breadCrumbData: [],
  className: '',
};
export default withStyles(errorBoundary(Breadcrumb), styles);
export { Breadcrumb as BreadcrumbVanilla };
